/*
 * Polyfill `SubmitEvent.submitter` in browsers with missing or lackluster support.
 * ┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅┅
 * References:
 *  - https://developer.mozilla.org/en-US/docs/Web/API/SubmitEvent/submitter
 *  - https://caniuse.com/mdn-api_submitevent_submitter
 *  - https://bugs.webkit.org/show_bug.cgi?id=229660
 */

;(window.requestIdleCallback || setTimeout)(() => {
  if (isSupported()) return

  addEventListener("click", updateSubmitter, { capture: true })

  Object.defineProperty((window.SubmitEvent || Event).prototype, "submitter", {
    get() {
      return getSubmitter(this)
    },
  })
})

const submittersByForm = new WeakMap()

function updateSubmitter(event) {
  const input = event.target.closest?.("input,button")
  if (input?.form) {
    submittersByForm.delete(input.form)
    if (input.type == "submit" && !event.defaultPrevented) {
      submittersByForm.set(input.form, input)
    }
  }
}

function getSubmitter(event) {
  if (event.type == "submit" && event.target instanceof HTMLFormElement) {
    return submittersByForm.get(event.target)
  }
}

function isSupported() {
  const cacheKey = "support:SubmitEvent.submitter"
  const cachedResult = sessionStorage.getItem(cacheKey)
  if (cachedResult) return cachedResult == "true"

  let result = false

  const form = Object.assign(document.createElement("form"), {
    innerHTML: `<button>X</button><button type=submit>X</button><input type=submit>`,
    hidden: true,
    onsubmit(event) {
      event.preventDefault()
      event.stopPropagation()
      result = Boolean(event.submitter)
    },
  })

  document.body.append(form)
  for (const submitter of form.elements) {
    submitter.onclick = (event) => event.stopPropagation()
    submitter.click()
    if (!result) break
  }
  form.remove()

  sessionStorage.setItem(cacheKey, result)
  return result
}
